import ResourceName from './ResourceName';

export default ResourceName;
